export default __webpack_public_path__ + "static/media/icon-burger.c1646a29.svg";